// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
//import { getAnalytics } from "firebase/analytics";
import { getFirestore, doc, getDoc, getDocs, collection, query, orderBy, setDoc, deleteDoc } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC9wfhCN-fzTTw_QxJ2iSKBc6k63-0jcio",
    authDomain: "saveliy-saunin.firebaseapp.com",
    databaseURL: "https://saveliy-saunin-default-rtdb.firebaseio.com",
    projectId: "saveliy-saunin",
    storageBucket: "saveliy-saunin.appspot.com",
    messagingSenderId: "130545780129",
    appId: "1:130545780129:web:426f762841b7a66e4f77e0",
    measurementId: "G-Y429RR9QBM"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// Initialize Cloud Firestore and get a reference to the service
const db = getFirestore(app);
const storage = getStorage(app);
export const auth = getAuth();

//const analytics = getAnalytics(app);

export const signIn = async (event) => {
    event.preventDefault();
    const { email, password } = event.target;
    if (email.value && password.value) {
        const result = signInWithEmailAndPassword(auth, email.value, password.value)
            .then((userCredential) => {
                // User signed in successfully
                return ({ success: true, user: userCredential.user });
            })
            .catch((error) => {
                // Error occurred during sign in
                const errorCode = error.code;
                const errorMessage = error.message;
                console.error({ code: errorCode, message: errorMessage });
                return ({ code: errorCode, message: errorMessage });
            });
        return result;
    } else {
        console.error({ code: "EmptyFields", message: 'Fill in all the fields' });
        return ({ code: "EmptyFields", message: 'Fill in all the fields' });
    }
}
export const logOut = async () => {
    signOut(auth)
        .then(() => {
            // Sign out successful
            console.log('User signed out');
            // Perform any additional actions after sign out
        })
        .catch((error) => {
            // An error occurred during sign out
            console.log('Sign out error:', error.message);
        });
}

export const uploadImage = async (path, image) => {
    // this function uploads the images to the firebase storage and retunrs the url of the image
    const storageRef = ref(storage, path); // the path where you want to store the images
    const imageRef = ref(storageRef, image.name);
    const imageURL = await uploadBytes(imageRef, image)
        .then(() => {
            console.log('Image uploaded successfully!');
            return getDownloadURL(imageRef);
        })
        .catch((error) => {
            console.error('Error uploading image:', error);
        });
    console.log('Image download URL:', imageURL);
    return (imageURL)

}
export const getProject = async (projectId) => {
    const docRef = doc(db, "projects", projectId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return (docSnap.data());
    } else {
        // doc.data() will be undefined in this case
        console.log("No such document!");
    }
}

export const getProjects = async () => {
    const querySnapshot = await getDocs(collection(db, "projects"));
    const projects = [];

    querySnapshot.forEach((doc) => {
        // doc.data() is never undefined for query doc snapshots
        projects.push(doc.data());
    });
    return (projects)
}

const segments2Ref = async (segments, l) => { // this function converts path segments to Firestore refrence
    if (l === 2 || l === 3) {
        // colection1/doc1 or colection1/doc1/field
        const docRef = doc(db, segments[0], segments[1]);
        return (docRef);
    } else if (l === 4 || l === 5) {
        // colection1/doc1/colection2/doc2 or colection1/doc1/colection2/doc2/field
        const parentDocRef = doc(db, segments[0], segments[1]);
        const docRef = doc(parentDocRef, segments[2], segments[3]);
        return (docRef);
    } else {
        console.error("Incorect firestore path:", segments)
    }
}

export const deleteDocument = async (path) => {
    const segments = path.split("/");
    const l = segments.length // short hand for length
    if (l === 2 || l === 4) {
        const reference = await segments2Ref(segments, l);
        const res = deleteDoc(reference)
            .then(() => {
                console.log(`Document ${segments[l - 1]} successfully deleted!`);
                return ({ success: true });
            })
            .catch((error) => {
                console.error("Error deleting document: ", error);
                return (error);
            });
        return (res)
    } else {
        console.error("Incorect firestore path:", path)
    }
}

export const updateData = async (path, data) => {
    // This function accepts converts it to an appropriate format and records the passed date to that adress.
    const segments = path.split("/");
    // split the path string to an array of strings
    // colection1/doc1/collection2/doc2/field -> [colection1,doc1,collection2,doc2,field] 
    const l = segments.length // short hand for length

    if (l > 1 && l <= 5) { // if the adress has between 2 and 5 segments
        let obj = {}; // create an empty object 
        // colection1/doc1
        const reference = await segments2Ref(segments, l); // convert segments array to Firestore reference
        if (l === 2 || l === 4) { // if the path does NOT have .../field value in the end
            obj = data; // set object to data
            //{...dataObj}
        } else if (l === 3 || l === 5) {// if the path HAS .../field value in the end
            obj[segments[l - 1]] = data; // convert the last segment of the path to object's main key
            //{fieldName:{...dataObj}}
        }
        const res = setDoc(reference, obj, { merge: true })
            .then(() => {
                console.log("Document successfully written!");
                return ({ success: true });
            })
            .catch((error) => {
                console.error("Error writing child document: ", error);
                return (error);
            });
        return (res)
    } else {
        console.error("Incorect firestore path:", path)
    }
}

export const getEntries = async (projectId) => {
    const entriesRef = collection(db, "projects", projectId, "entries");
    let q = query(entriesRef, orderBy("date", "desc"));

    // if (lastDocWas) {
    //     const nextQ = query(entriesRef, startAfter(lastDocWas), limit(10));
    //     q = nextQ;
    // }

    const querySnapshot = await getDocs(q);
    const entries = querySnapshot.docs.map((doc) => {
        return { id: doc.id, ...doc.data() };
    });

    //const lastDocIs = querySnapshot.docs[querySnapshot.docs.length - 1];

    return (entries)
}
